export default {
    bind(el, binding, vnode) {
        let isDragging = false;
        let targetEl = null;
        let container = null;
        let bottomEl = null;

        const startDrag = (e) => {
            isDragging = true;
            document.body.style.cursor = 'row-resize';
            e.preventDefault();
        };

        const stopDrag = () => {
            isDragging = false;
            document.body.style.cursor = 'default';
        };

        const onMouseMove = (e) => {
            if (!isDragging || !targetEl) return;

            // 컨테이너가 없으면 상위 요소 찾기
            if (!container) {
                container = targetEl.parentNode;
            }

            // 하단 요소(ExperimentResult) 찾기
            if (!bottomEl) {
                // divider 다음에 오는 요소가 하단 요소일 것입니다
                bottomEl = el.nextElementSibling;
            }

            const containerHeight = container.clientHeight;
            const containerOffsetTop = container.offsetTop;
            const newTopHeight = e.clientY - containerOffsetTop;

            // 최소 높이 제한 (상단, 하단 모두)
            const minHeight = 50;
            if (newTopHeight < minHeight || containerHeight - newTopHeight - el.offsetHeight < minHeight) {
                return;
            }

            // 상단 패널 높이 설정
            targetEl.style.height = `${newTopHeight}px`;

            // 하단 요소 높이를 자동으로 조정하도록 처리
            // 직접 높이를 설정하기보다는 flex 레이아웃을 활용하는 것이 더 좋을 수 있습니다
            const remainingHeight = containerHeight - newTopHeight - el.offsetHeight;
            if (bottomEl) {
                bottomEl.style.height = `${remainingHeight}px`;
            }
        };

        el.addEventListener('mousedown', startDrag);
        document.addEventListener('mouseup', stopDrag);
        document.addEventListener('mousemove', onMouseMove);

        el._resizable = {
            startDrag,
            stopDrag,
            onMouseMove
        };

        // target 찾기
        vnode.context.$nextTick(() => {
            if (binding.value && binding.value.target) {
                targetEl = vnode.context.$refs[binding.value.target];
                // 컨테이너와 하단 요소는 마우스 이동 시 처음으로 찾을 것입니다
            }
        });
    },

    unbind(el) {
        if (el._resizable) {
            el.removeEventListener('mousedown', el._resizable.startDrag);
            document.removeEventListener('mouseup', el._resizable.stopDrag);
            document.removeEventListener('mousemove', el._resizable.onMouseMove);
            delete el._resizable;
        }
    }
};